<script lang="ts">
    import {OwnerDetails} from "../../models/OwnerDetails";
    import {USState} from "../../models/USState";
    import {getAllUSStates, Suffixes} from "../../services/ApplicationDataService";
    import Address from "../controls/Address.svelte";
    export let ownerDetails: OwnerDetails
    let suffixes: string[]
    let usStates: USState[];
    suffixes = Suffixes();
    usStates = getAllUSStates();

</script>

<div class="text-section">
    {#if ownerDetails}
        {#if ownerDetails.ownerType == "2"}
            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>First Name:</label>
                    <input bind:value={ownerDetails.personFirst} />
                </div>
            </div>
            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>Middle Name:</label>
                    <input bind:value={ownerDetails.personMiddle} />
                </div>
            </div>
            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>Last Name:</label>
                    <input bind:value={ownerDetails.personLast} />
                </div>
            </div>

            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>Suffix:</label>
                    <select bind:value={ownerDetails.personSuffix} >
                        <option value=''> Select Suffix </option>
                        {#each suffixes as suffix}
                            <option value={suffix}> {suffix}
                            </option>
                        {/each}
                    </select>

                </div>
            </div>
        {:else if ownerDetails.ownerType == "3"}
            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>Company Name:</label>
                    <input bind:value={ownerDetails.companyName} />
                </div>
            </div>
        {:else if ownerDetails.ownerType == "4"}
            <div class="control-row">
                <div class="control-group-horizontal">
                    <label>Trust Name:</label>
                    <input bind:value={ownerDetails.trustName} />
                </div>
            </div>
        {/if}
        {#if ownerDetails.ownerType == "2" || ownerDetails.ownerType == "3" || ownerDetails.ownerType == "4" }
            <Address bind:address={ownerDetails.address} showLengthOfResidence= "false"/>
        {/if}
    {/if}
</div>


<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
</style>
